import { combineReducers } from "redux";
import { questionState} from "./questionsReducer";

export const questionsReducer = combineReducers({
    questionState: questionState
});